export const AUMENTO_DE_PLAZO = 'Aumento de Plazo';
export const SOLICITUDES_VARIAS = 'Solicitudes Varias';

export const ACUCORE = 'Acuerdo CORE';
export const ACTRE = 'Acta Recepción de bienes o servicios';
export const MEMO = 'Memorándum';
export const OFICIO = 'Oficio';
export const OFCORE = 'Oficio CORE';
export const RES = 'Resolución Exenta';
export const RESUGDPS = 'Resolución Exenta UGDP-S';
export const BIT = 'Bitácora 2024';
export const CEF = 'Certificado Ejecución Financiera';
export const ODP = 'Orden de Pago con Cargo a Gasto de Representación';
export const SP = 'Solicitud de Presupuesto 2024';
export const SCP = 'Solicitud Compra de Pasajes';
export const INF = 'Informe de uso y custodia de vehículos fiscales';
export const SOGR = 'Solicitud Gasto de Representación';
export const SEGR = 'Selección Proveedor Gasto de Representación';
export const IDPC = 'Informe de Desempeño Proceso de Calificaciones';
